import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { GridColumn } from '@/models/GridColumn.model';
import { AdpFileControlSelectItemModel } from '@/models/backoffice/AdpFileControlSelectItemModel';
import MockData from '@/globals/mock';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { Action, Getter, Mutation } from 'vuex-class';
import {
  ADP_FILES_ERRORS,
  ADP_FILES_LIST,
  ADP_FILES_LOADING,
  APD_CUSTOMERS,
  GET_ADP_CUSTOMERS,
  GET_ADP_FILE, SET_ADP_CUSTOMERS,
  SET_ADP_FILES,
  SET_ADP_FILES_ERRORS,
  SET_ADP_FILES_LOADING,
  DOWNLOAD_ADP_FILES,
} from '@/types/adp-file-control.types';
import { Grid } from '@/models/Grid.model';
import { AdpFileControlModel } from '@/models/backoffice/AdpFileControlModel';
import { AdpFileControlSearchModel } from '@/models/backoffice/AdpFileControlSearchModel';
import { Utils } from '@/globals/Utils';
import { ClickColumn } from '@/models/ClickColumn.model';


@Component({})
export default class AdpFileControlComponent extends Vue {

  @Action(GET_ADP_FILE, StoreNamespace.ADP_FILE_CONTROL) public searchAdpFile;
  @Action(GET_ADP_CUSTOMERS, StoreNamespace.ADP_FILE_CONTROL) public getAdpCustomers;
  @Action(DOWNLOAD_ADP_FILES, StoreNamespace.ADP_FILE_CONTROL) public downloadAdpFiles;

  @Mutation(SET_ADP_FILES_ERRORS, StoreNamespace.ADP_FILE_CONTROL) public setAdpFilesControlErrors;
  @Mutation(SET_ADP_FILES_LOADING, StoreNamespace.ADP_FILE_CONTROL) public setAdpFilesControlLoading;
  @Mutation(SET_ADP_FILES, StoreNamespace.ADP_FILE_CONTROL) public setAdpFilesControl;

  @Getter(ADP_FILES_LIST, StoreNamespace.ADP_FILE_CONTROL) public adpFileControlList!: Grid<AdpFileControlModel>;
  @Getter(ADP_FILES_ERRORS, StoreNamespace.ADP_FILE_CONTROL) public adpFilesControlErrors!: string;
  @Getter(ADP_FILES_LOADING, StoreNamespace.ADP_FILE_CONTROL) public adpFilesControlLoading!: boolean;
  @Getter(APD_CUSTOMERS, StoreNamespace.ADP_FILE_CONTROL) public adpCustomers!: Grid;

  @Prop(String) public triggerSearch!: string;

  private adpFileControlColumns: GridColumn[] = [];
  private cleared = false;
  private customersOptions: AdpFileControlSelectItemModel[] = MockData.adpFiles.customersOptions;
  private adpFilesCubesOptions: AdpFileControlSelectItemModel[] = MockData.adpFiles.adpFilesCubesOptions;

  private static getEmptyAdpFileControlSearchObject(): AdpFileControlSearchModel {
    return {
      indexNum: null,
      dateFrom: null,
      dateTo: null,
      groupType: undefined,
    };
  }

  public filesAdpControlSearchObject: AdpFileControlSearchModel = AdpFileControlComponent.getEmptyAdpFileControlSearchObject();

  public created() {
    this.initAdpFilesColumns();
  }

  public mounted() {
    this.getAdpCustomers();
    this.setAdpFilesControlLoading(false);
    this.setAdpFilesControlErrors([]);
    if (this.triggerSearch) {
      setTimeout(() => {
        this.$emit('fetchSearch', this.filesAdpControlSearchObject);
      }, 100);
    }
  }

  private initAdpFilesColumns() {
    this.adpFileControlColumns.push({
      property: 'groupType',
      header: 'back_office.adp_file_control.group_type',
      hideSorting: true,
    } as GridColumn);
    this.adpFileControlColumns.push({
      property: 'productionDate',
      header: 'back_office.adp_file_control.production_date',
      hideSorting: true,
    } as GridColumn);
    this.adpFileControlColumns.push({
      property: 'fileName',
      header: 'back_office.adp_file_control.file_name',
      hideSorting: true,
    } as GridColumn);
    this.adpFileControlColumns.push({
      property: 'noOfInsertedRows',
      header: 'back_office.adp_file_control.insert_records',
      hideSorting: true,
    } as GridColumn);
    this.adpFileControlColumns.push({
      property: 'noOfDeleteRows',
      header: 'back_office.adp_file_control.delete_records',
      hideSorting: true,
    } as GridColumn);
    this.adpFileControlColumns.push({
      clickEvent: 'DOWNLOAD_FILE',
      faIcon: 'download',
      faIconType: 'fal',
      header: 'back_office.adp_file_control.download',
      hideSorting: true,
    } as ClickColumn);
  }

  public updateDateFrom(date: Date) {
    this.filesAdpControlSearchObject.dateFrom = date ? Utils.dateToString(date) : date;
  }

  public updateDateTo(date: Date) {
    this.filesAdpControlSearchObject.dateTo = date ? Utils.dateToString(date) : date;
  }

  private onSearch() {
    this.setAdpFilesControlLoading(true);
    this.setAdpFilesControlErrors([]);
    this.searchAdpFile(this.filesAdpControlSearchObject);
  }

  private onClear() {
    this.cleared = true;
    this.setAdpFilesControlErrors([]);
    this.setAdpFilesControl({} as Grid);
    this.filesAdpControlSearchObject = AdpFileControlComponent.getEmptyAdpFileControlSearchObject();
    setTimeout(() => {
      this.cleared = false;
    });
  }

  public onTdClicked(item, column) {
    switch (column.clickEvent) {
      case 'DOWNLOAD_FILE':
        this.downloadAdpFiles({ fileId: item.id, fileName: item.fileName });
        break;
    }
  }

  private beforeDestroy() {
    this.setAdpFilesControlErrors([]);
    this.setAdpFilesControl({} as Grid);
    this.filesAdpControlSearchObject = AdpFileControlComponent.getEmptyAdpFileControlSearchObject();
  }
}